export const BG_COLOR = 'none';
export const TITLE_FONT_SIZE = '3rem';
export const TITLE_FONT_WEIGHT = 'normal';
